import { render, staticRenderFns } from "./HoursSpent.vue?vue&type=template&id=ebf00bae&scoped=true"
import script from "./HoursSpent.vue?vue&type=script&lang=js"
export * from "./HoursSpent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf00bae",
  null
  
)

export default component.exports